import { EditorDatePickerFields } from "./DatePickerFields";
import { EditorTextFields } from "./TextFields";
import { EditorNumberFields } from "./NumberFields";
import { EditorSelectionFields } from "./SelectionField";
import { EditorAutocompleteFields } from "./MuiSelectFields";
import { EditorCheckboxFields } from "./CheckboxField";
import { EditorDropzoneFields } from "./DropzoneFields";
import { EditorSliderFields } from "./SliderFields";
import { EditorListFields } from "./ListField";

export * from "./formatters/number";
export * from "./formatters/date";
export * from "./formatters/extractNumberFormat";

export * from "./helpers/IntlDateTimePicker";
export * from "./helpers/IntlNumberField";
export * from "./DployTextField";
export * from "./DployAutocomplete";
export * from "./Dropzone";

export * from "./DatePickerFields";
export * from "./NumberFields";
export * from "./SliderFields";
export * from "./TextFields";
export * from "./MuiSelectFields";
export * from "./SelectionField";
export * from "./CheckboxField";
export * from "./DropzoneFields";
export * from "./ListField";

export { useSelectedField } from "./SelectedField/useSelectedField";

export { FieldRoleData } from "./types";
export { FieldActionData } from "./types";

export {
	MuiAutocompleteField as AutocompleteField,
	MuiSelectField as SelectField
} from "./MuiSelectFields";

export {
	formatToParts,
	identityRecordOfFieldEditorOptions,
	identity,
	getFieldError,
	getNoTouchError,
	defaultGetItemLabel,
	defaultGetItemValue
} from "./utils";
export {
	BaseFieldProps,
	HasItems,
	FieldEditorOptions,
	SectionEditorOptions
} from "./types";
export { useFormikOnError } from "./hooks";

export const EditorFields = {
	...EditorDatePickerFields,
	...EditorNumberFields,
	...EditorTextFields,
	...EditorSelectionFields,
	...EditorCheckboxFields,
	...EditorDropzoneFields,
	...EditorAutocompleteFields,
	...EditorSliderFields,
	...EditorListFields,
	AutocompleteField: EditorAutocompleteFields.MuiAutocompleteField,
	SelectField: EditorAutocompleteFields.MuiSelectField,
	ListField: EditorListFields.ListField
};
